import styled from 'styled-components';
import { Field, Form } from 'formik';
import Checkbox from '@carvana/forms/Checkbox';
import { AlertCircle } from '@carvana/icons';
import { cvBreakpoint768 } from '@carvana/theme';

const commonStyles = {
  labelPaddingSize: '12px',
  labelTextRetract: {
    fontSize: '12px',
    transform: 'translateY(-8px)',
    transition: 'all 0.1s ease-in'
  }
};

export const WizardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 700px;
`;

export const WizardProgressBar = styled.progress`
  -webkit-appearance: none;
  height: 4px;
  width: 100%;

  &::-webkit-progress-bar {
    background: ${props => props.theme.carvana.gray.light};
  }

  &::-webkit-progress-value {
    background-color: ${props => props.theme.carvana.green.primary};
    transition: width .5s ease .75s;
  }
`;

export const WizardFormsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-bottom: 30px;

  @media (min-width: ${cvBreakpoint768}px) {
    flex-direction: row;
    padding-bottom: initial;
  }
`;

export const WizardSection = styled.section`
  display: flex;
  flex-basis: 100%;
  justify-content: center;

  @media (min-width: ${cvBreakpoint768}px) {
    flex-basis: 50%;
  }
`;

export const WizardHeading = styled.h3`
  color: ${props => props.theme.carvana.blue.dark};
  text-transform: capitalize;
`;

export const WizardText = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
  line-height: 1.5;
`;

export const WizardForm = styled(Form)`
  padding: 40px 24px 20px;
`;

export const FormHeading = styled(WizardHeading)`
  font-size: 18px;
  margin-bottom: 20px;

  @media (min-width: ${cvBreakpoint768}px) {
    font-size: 22px;
  }
`;

export const FormQuestion = styled(WizardText)`
  margin-bottom: 18px;
`;

export const Label = styled.label`
  align-items: flex-end;
  background-color: ${props => props.theme.carvana.gray.background};
  border: 1px solid ${props => props.theme.carvana.gray.light};
  border-radius: 4px;
  color: ${props => props.theme.carvana.gray.dark};
  cursor: pointer;
  display: flex;
  font-weight: bold;
  height: 56px;
  max-width: 300px;
  padding: 0 ${commonStyles.labelPaddingSize} 10px;
  position: relative;
  text-transform: uppercase;
`;

export const LabelText = styled.span`
  left: ${commonStyles.labelPaddingSize};
  line-height: 1;
  position: absolute;
  top: calc(50% - 8px);
  transition: all 0.2s ease-in;
  z-index: 1;

  &.shrink {
    ${commonStyles.labelTextRetract}
  }
`;

export const FormField = styled(Field)`
  background-color: transparent;
  border: none;
  color: ${props => props.theme.carvana.blue.dark};
  cursor: pointer;
  font-weight: bold;
  outline: none;
  padding: 0;

  &:focus ~ ${LabelText} {
    ${commonStyles.labelTextRetract}
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  *[type=number] {
    -moz-appearance: textfield;
  }
`;

export const FormCheckbox = styled(Checkbox)`
  align-items: center;
  display: flex;
  margin: 30px 0;

  & > label {
    color: ${props => props.theme.carvana.gray.dark};
    font-size: 14px;
    line-height: 1.5;
    margin-left: 12px;
    padding-top: 0;
  }
`;

export const AlertIcon = styled(AlertCircle)`
  align-self: center;
  margin-bottom: 12px;

  & > svg {
    height: 32px;
    width: 32px;
  }

  & > svg > g {
    fill: ${props => props.red
      ? props.theme.carvana.red.primary
      : props.theme.carvana.yellow.primary};
  }
`;